<script>
	import { createEventDispatcher } from "svelte";
	import { uiText } from "../lib/uiText.js";
	import {
		doc,
		setDoc,
		getDoc,
		updateDoc,
		collection,
		addDoc,
		// arrayUnion,
		// onSnapshot,
		// deleteField,
		serverTimestamp,
		// increment,
		// query,
		// limit,
		// orderBy,
	} from "firebase/firestore";

	const dispatch = createEventDispatcher();

	// export let auth;
	export let db;
	export let lang;
	export let loader;
	export let user;
	let ui = uiText(lang);
	$: lang,
		(ui = uiText(lang)),
		dispatch("setLang", { lang: lang, prefset: true });
	$: loader, dispatch("loader", loader), (ui = uiText(lang));

	let code_created = false;

	let codeSet = {
		product: "",
		code: "",
		single_use: true,
		allowed_uses: 1,
		unlimited: false,
		productName: "",
		ordered_by: "",
		issued_by: { name: user.name, uid: user.uid },
		vendor: "vg-admin",
	};

	let vendors = {
		names: ["VG Admin"],
		values: ["vg-admin"],
	};

	function makeID(length) {
		var result = "";
		// var characters = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';
		var characters = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
		var charactersLength = characters.length;
		for (var i = 0; i < length; i++) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
		}
		return result;
	}

	async function saveCodeSet() {
		let data = codeSet;

		if (data.code == "") {
			data.code = makeID(8);
		}

		let codeSetObject = {
			product: data.product,
			code: data.code,
			game_on: false,
			game_over: false,
			used_by: null,

			...(data.single_use == true && {
				unlimited: false,
			}),
			...(data.single_use == false &&
				data.unlimited == false && {
					unlimited: data.allowed_uses,
				}),

			...(data.single_use == false &&
				data.unlimited == true && {
					unlimited: true,
				}),

			productName: data.productName,
			ordered_by: data.ordered_by,
			issued_by: data.issued_by,
			vendor: data.vendor,
		};

		const codeSetRef = doc(db, "game-activation-codes", data.code);

		const checkSnap = await getDoc(codeSetRef);

		if (checkSnap.exists()) {
			console.log("This code already exists!");
			alert("This code already exists!");

			if (confirm("Are you sure you want to update the code?")) {
				console.log("Updating existing code...");
				await updateDoc(codeSetRef, { ...codeSetObject }, { merge: true }).then(
					() => {
						console.log("DONE");
						alert("Code updated");
						code_created = true;
					}
				);
			} else {
				console.log("Nothing changed!");
				alert("No changes were made.");
			}
		} else {
			if (
				confirm("This code doesn't exist. Are you sure you want to create it?")
			) {
				await setDoc(codeSetRef, { ...codeSetObject }, { merge: true }).then(
					() => {
						console.log("DONE");
						alert("Code created");
						code_created = true;
					}
				);
			} else {
				console.log("Nothing changed!");
				alert("No changes were made.");
			}
		}
	}

	let temp;
	let hasCC, hasBCC;
	let emailSet = {
		recepients: [codeSet.ordered_by],
		cc: [],
		bcc: [],
	};
	$: emailSet.recepients[0] = codeSet.ordered_by;

	async function sendEmailWithCode() {
		let query_doc;
		switch (lang) {
			case "en":
				query_doc = "gamecode_email_template_en";
				break;
			case "bg":
				query_doc = "gamecode_email_template_bg";
				break;
			default:
				query_doc = "gamecode_email_template_en";
		}

		let email, html_compose, text_compose;

		const emailSetRef = doc(db, "templates", query_doc);
		const emailSnap = await getDoc(emailSetRef);

		if (emailSnap.exists()) {
			email = emailSnap.data();

			html_compose = email.html
				.replace("{{game_name}}", codeSet.productName)
				.replace("{{game_code}}", codeSet.code);
			text_compose = email.text
				.replace("{{game_name}}", codeSet.productName)
				.replace("{{game_code}}", codeSet.code);

			console.log(text_compose);
		} else {
			console.log("No such document!");
		}

		const autoSendRef = collection(db, "autosendmail");

		await addDoc(
			autoSendRef,
			{
				to: emailSet.recepients,
				cc: emailSet.cc,
				bcc: emailSet.bcc,
				message: {
					subject: email.subject,
					html: html_compose,
					text: text_compose,
				},
				timeOfSending: serverTimestamp(),
			},
			{ merge: true }
		).then(() => {
			console.log("DONE");
			alert("Mail sent!");
		});
	}
</script>

<!--  -->
<!--  -->
<!--  -->
<p class="mt-6 uppercase">VG Panel</p>
<h1>GAC Generator</h1>

<div class="flex flex-wrap">
	<div class="grid grow sm:grow-0">
		<label for="gid">GID (product):</label>
		<input
			type="text"
			name="gid"
			maxlength="10"
			id="gid"
			bind:value={codeSet.product}
			placeholder="Game ID"
			title="Game ID"
		/>
	</div>

	<div class="grid grow min-w-[50vw]">
		<label for="des_code">Desired code:</label>
		<input
			type="text"
			name="des_code"
			id="des_code"
			maxlength="8"
			bind:value={codeSet.code}
			placeholder="Leave blank for random"
			title="Desired code"
		/>
	</div>
</div>
<div class="flex flex-wrap">
	<div class="grid content-start grow sm:grow-0">
		<label for="start_title">Ordered by:</label>
		<input
			type="email"
			name="ordered_by"
			id="ordered_by"
			bind:value={codeSet.ordered_by}
			placeholder="em@il.com"
			title="Ordered by"
		/>
	</div>

	<div class="grid grow min-w-[50vw]">
		<label for="start_title">Product name:</label>
		<input
			type="text"
			name="prod_name"
			id="prod_name"
			bind:value={codeSet.productName}
			placeholder="Mission name (gift)"
			title="Product name"
		/>
	</div>
</div>

<div class="flex flex-wrap">
	<div class="grid grow gap-4">
		<div class="flex">
			<input
				type="checkbox"
				name="single_use"
				id="single_use"
				bind:checked={codeSet.single_use}
			/><label for="single_use">Single use</label>
		</div>

		{#if !codeSet.single_use}
			<div class="flex">
				<input
					type="checkbox"
					name="unlimited_use"
					id="unlimited_use"
					bind:checked={codeSet.unlimited}
				/><label for="unlimited_use">Unlimited use</label>
			</div>
		{/if}
	</div>

	<!-- {#if !codeSet.unlimited} -->
	<div class="grid grow">
		<label for="order-rows">Allowed uses</label>
		<input
			disabled={codeSet.unlimited || codeSet.single_use}
			type="number"
			name="order-rows"
			id="order-rows"
			min="1"
			placeholder="Leave blank for unlimited"
			bind:value={codeSet.allowed_uses}
		/>
	</div>
	<!-- {/if} -->

	<select bind:value={codeSet.vendor}>
		{#each vendors.names as type, i}
			<option value={vendors.values[i]}>{type}</option>
		{/each}
	</select>
</div>

<div class="grid flex-wrap sm:flex">
	<button
		on:click={saveCodeSet}
		class="order-first secondary grow sm:order-none"
	>
		<i class="fa-solid fa-floppy-disk" data-position="left" />Save Code</button
	>
</div>

{#if code_created}
	Proceed to send email

	{#each emailSet.recepients as recepient, i}
		<div class="flex">
			<input
				type="text"
				name={"em_rec_" + i}
				id={"em_rec_" + i}
				bind:value={emailSet.recepients[i]}
				class=" grow"
				disabled={i == 0}
			/>

			<i>
				{i + 1}
			</i>
			{#if i != 0}
				<button
					on:click={() => (
						(temp = emailSet.recepients.splice(i, 1)),
						(emailSet.recepients = emailSet.recepients)
					)}
					class="secondary"><i class="fa-solid fa-minus" /></button
				>
			{/if}
		</div>
	{/each}
	<button on:click={() => emailSet.recepients.length++}>
		<i class="fa-solid fa-plus" data-position="left" />New recepient</button
	>

	<div class="flex">
		<input type="checkbox" name="cc_" id="cc_" bind:checked={hasCC} /><label
			for="cc_">Send CC:</label
		>
	</div>

	{#if hasCC}
		{#each emailSet.cc as recepient, i}
			<div class="flex">
				<input
					type="text"
					name={"em_rec_" + i}
					id={"em_rec_" + i}
					bind:value={emailSet.cc[i]}
					class=" grow"
				/>

				<i>
					{i + 1}
				</i>
				{#if i != 0}
					<button
						on:click={() => (
							(temp = emailSet.cc.splice(i, 1)), (emailSet.cc = emailSet.cc)
						)}
						class="secondary"><i class="fa-solid fa-minus" /></button
					>
				{/if}
			</div>
		{/each}
		<button on:click={() => emailSet.cc.length++}>
			<i class="fa-solid fa-plus" data-position="left" />New CC</button
		>
	{/if}

	<div class="flex">
		<input type="checkbox" name="bcc_" id="bcc_" bind:checked={hasBCC} /><label
			for="bcc_">Send BCC:</label
		>
	</div>

	{#if hasBCC}
		{#each emailSet.bcc as recepient, i}
			<div class="flex">
				<input
					type="text"
					name={"em_rec_" + i}
					id={"em_rec_" + i}
					bind:value={emailSet.bcc[i]}
					class=" grow"
				/>

				<i>
					{i + 1}
				</i>
				{#if i != 0}
					<button
						on:click={() => (
							(temp = emailSet.bcc.splice(i, 1)), (emailSet.bcc = emailSet.bcc)
						)}
						class="secondary"><i class="fa-solid fa-minus" /></button
					>
				{/if}
			</div>
		{/each}
		<button on:click={() => emailSet.bcc.length++}>
			<i class="fa-solid fa-plus" data-position="left" />New BCC</button
		>
	{/if}

	<div class="grid flex-wrap sm:flex">
		<button
			on:click={sendEmailWithCode}
			class="order-first secondary grow sm:order-none"
		>
			<i class="fa-solid fa-envelope" data-position="left" />Send Email with
			Code</button
		>
	</div>
{/if}

<div class="grid gap-4" />

<style>
	:global(.obelisk select) {
		box-sizing: border-box;

		place-content: center;
		--tw-bg-opacity: 1;
		background-color: rgb(255 255 255 / var(--tw-bg-opacity));
	}
	:global(.obelisk select) {
		margin: 10px;
		padding: 15px;
		border-radius: 0px;
		box-shadow: #093a86 5px 5px 0;
		color: #05204a;
	}
</style>
